export default [
    {
        path: '/setting/staff',
        name: 'SettingStaffList',
        component: () => import('@/pages/setting/staff/List.vue'),
        meta: {
            title: '员工管理',
            requireAuth: true,
            authority: 'setting:staff'
        }
    },
    {
        path: '/setting/role',
        name: 'SettingRoleList',
        component: () => import('@/pages/setting/role/List.vue'),
        meta: {
            title: '角色管理',
            requireAuth: true,
            authority: 'setting:role'
        }
    },
    {
        path: '/setting/department',
        name: 'SettingDepartmentList',
        component: () => import('@/pages/setting/department/List.vue'),
        meta: {
            title: '部门管理',
            requireAuth: true,
            authority: 'setting:department'
        }
    },
    {
        path: '/setting/menu',
        name: 'SettingMenuList',
        component: () => import('@/pages/setting/menu/List.vue'),
        meta: {
            title: '菜单管理',
            requireAuth: true,
            authority: 'setting:menu'
        }
    }
]


// WEBPACK FOOTER //
// ./src/router/module/setting.js